// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Stack,
  Box,
  Typography,
  SubmitButton,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import type { ManageGrossRentsEmptyStateProps } from './types';

const ManageGrossRentsEmptyState = ({
  message,
  onRetry,
  isRetrying = false,
  retryMessage,
  sx,
}: ManageGrossRentsEmptyStateProps) => (
  <Box
    sx={{
      mt: 2,
      borderRadius: 1,
      border: 1,
      borderColor: 'divider',
      backgroundColor: 'grey.50',
      minHeight: 400,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...sx,
    }}
  >
    <Stack
      alignItems="center"
      spacing={2}
      sx={{ py: 10, color: 'text.secondary' }}
    >
      <Typography variant="titleMedium" color="text.secondary" align="center">
        <FormattedMessage {...message} />
      </Typography>
      {onRetry != null && retryMessage != null ? (
        <SubmitButton
          variant="primary"
          onClick={onRetry}
          isSubmitting={isRetrying}
        >
          <FormattedMessage {...retryMessage} />
        </SubmitButton>
      ) : null}
    </Stack>
  </Box>
);

export default ManageGrossRentsEmptyState;
